// Поиск по карте мира: места, игроки, участки.
//
// Карта становится полноэкранной, и в ней можно не только смотреть, но и
// искать: «спавн», «Mia», «участок 3» — клик по результату телепортирует.
// Модуль чистый и покрыт тестами; интерфейс только рисует.

const norm = value => String(value ?? '').trim().toLowerCase()

// Собирает единый индекс из того, что клиент и так знает.
export function buildMapIndex({ destinations = [] } = {}) {
  return destinations.filter(row => row?.id && row?.label).map(row => ({
    id: String(row.id), kind: row.kind === 'plot' ? 'plot' : 'place', label: String(row.label),
    hint: row.kind === 'plot' ? 'земля' : 'место', version: Number(row.version),
    available: row.available !== false, ownerName: row.ownerName || null,
    keywords: [row.label, row.id, row.kind === 'plot' ? `участок ${String(row.id).split(':')[1]} земля` : 'место'],
  }))
}

// Поиск: пустой запрос — всё (места и участки вперёд), иначе по подстроке в
// названии и синонимах, совпадение в начале — выше.
export function searchMap(query, index) {
  const needle = norm(query)
  if (!needle) return index
  const scored = []
  for (const row of index) {
    let score = 0
    for (const keyword of [row.label, ...(row.keywords || [])]) {
      const text = norm(keyword)
      if (!text.includes(needle)) continue
      score = Math.max(score, text.startsWith(needle) ? 2 : 1)
    }
    if (score > 0) scored.push({ row, score })
  }
  return scored.sort((left, right) => right.score - left.score || left.row.label.localeCompare(right.row.label)).map(item => item.row)
}
